module.exports = __webpack_public_path__ + "img/keyboard_Enter.36404256.png";